module.exports = __webpack_public_path__ + "static/media/6.55feef4d.jpg";